export default __webpack_public_path__ + "images/assets/5b2837eb44ec8182e7f788ce2e8848d9.svg";